import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { authGuard } from './guard/auth.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { AppErrorComponent } from './pages/error/error.component';
import { PublicLayoutRoutes } from './routes';
import { MainLayoutRoutes } from './routes/main-layout.routes';
import { FullLayoutRoutes } from './template/routes';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: MainLayoutRoutes,
    canActivate: [authGuard]
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: PublicLayoutRoutes
  },
  {
    path: 'template',
    children: FullLayoutRoutes,
    canMatch: [() => environment.enableTemplate], // only enable in dev env,
    canActivate: [authGuard]
  },
  {
    path: '**',
    component: AppErrorComponent
  }
];
